// eslint-disable-next-line max-len
import { Component, OnInit, EventEmitter, Output, Input, ViewContainerRef, ViewChild, ViewChildren, ElementRef, ChangeDetectorRef, Inject, Optional, AfterViewInit, HostListener, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators, } from "@angular/forms";
import {  BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import * as moment from "moment";
import {  Router } from "@angular/router";
import { RestService } from "../../../../shared/rest.service";
import { Observable } from "rxjs/Observable";
import { AddressesService } from "../../service/addresses.service";
import { UbicacionesService } from "../../service/ubicaciones.service";
import { IAddreSelect } from "./interface/IAddreSelect";
import { searchPayload } from "../../../../utils/search-functions";
import { UserService } from "../../../../pages/com.usblick.common/auth/user.service";
import { ConfirmationModalComponent } from "../../../../shared/modals/confirmation-modal/confirmation-modal.component";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import * as dayjs from 'dayjs';
import { DaterangepickerDirective } from "ngx-daterangepicker-material";
import { of, Subject } from "rxjs";
import { filter, switchMap, take, takeUntil } from "rxjs/operators";
import { ItineraryService } from "app/shared/itinerary.service";
import { NotFoundModalComponent } from "app/shared/modals/not-found-modal/not-found-modal.component";
import { DateRangePickerService } from "app/shared/date-range-picker/date-range-picker.service";
import { MatAutocomplete, MatAutocompleteTrigger } from "@angular/material/autocomplete";
@Component({
  selector: "usb-rentcars",
  templateUrl: "./rentcars.component.html",
  styleUrls: ["./rentcars.component.scss"],
  providers: [AddressesService, UbicacionesService],
})
export class RentcarsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() getClientsSettingAppBooking: any;
  @Output() origin = new EventEmitter<any>();
  @Output() payload = new EventEmitter<any>();
  @Output() results = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() modal = new EventEmitter<string>();
  @ViewChild(DaterangepickerDirective) picker!: DaterangepickerDirective;
  @ViewChild('dateRangePicker') dateRangePicker: DaterangepickerDirective;
  @Input() _close: boolean;
@ViewChild('auto') auto: MatAutocomplete;
  @ViewChild('autoOrigin') autoOrigin: MatAutocomplete;
  @ViewChild('autoDestination') autoDestination: MatAutocomplete;
  @ViewChild('originTrigger') originTrigger: MatAutocompleteTrigger;
  @ViewChild('destinationTrigger') destinationTrigger: MatAutocompleteTrigger;
  @ViewChild("destination", {static:true}) myInputField: ElementRef;

  @ViewChildren(DaterangepickerDirective) pickerDirectiveAll;
  private calendarSync: DateRangePickerService;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };
  ngSelectHourOrigin = '10:00';
  ngSelectHourDestination = '10:00';
  ageDefault = '25';
  selectedDate: { startDate: moment.Moment; endDate: moment.Moment; };
  bsModalRef?: BsModalRef;
  bgClientColor: string;
  _form: FormGroup;
  //minDate: Date;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  isMeridian: boolean;
  _findData: boolean;
  isCollapsed: boolean;
  mytime: any;
  _resultsQuery: any;
  selectedDestiny: any;
  selectedOrigin: any;
  _longDestination: string;
  _longOrigin: string;
  _origin: any;
  destiny: any;
  isHoveredCancelDate: boolean;
  selectNationalityName: string = '';
  public selectNationality: string = '';
  public countriesData: any[] = [];
  public filteredCountries: any[] = [];
  startDate: any;
  endDate: any

  returnDestinations: boolean;
  _addressOriginRentaCar: IAddreSelect[];
  addreOriginSelected: IAddreSelect;
  _addressDestinyRentaCar: IAddreSelect[];
  addreDestinySelected: IAddreSelect;
  hourDestiny: Date;
  hourOrigin: Date;

  originOptions: Observable<any[]> = of([]);
  originOptions_: Observable<any[]> = of([]);

  destinationOptions: Observable<any[]> = of([]);
  destinationOptions_: Observable<any[]> = of([]);
  typeOrigin:string;
  typeDestination: string;

  isLoading_ = false;

  /**
   * Identifica cuál mat-autocomplete está abierto actualmente.
   * Se setea en `onAutocompleteOpened` y se limpia en `onAutocompleteClosed`.
   * Sirve para que los hooks de estilo apunten al panel correcto.
   */
  activeAutocomplete: 'origin' | 'destination' | null = null;

  minDate: dayjs.Dayjs = dayjs().subtract(0, 'days');
  maxDate: dayjs.Dayjs = dayjs().add(12, 'month');
  dateRange: any = { start: null, end: null };

  dateStarEnd:any;
  dateStart: any;
  dateEnd: any;
  times = []; // time array
  agencyId:any;
  // Must default to true: agencyData() triggers detectChanges before _form exists.
  componentResults: boolean;
  loadingData: boolean = true;
  messageValidateAge:string;
  originInputValue:string = '';
  destinyInputValue: string = '';
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  componentResultsFirstCharge: boolean = true;
  routerStorage: any;
  typeOriginDestination: any = {
    origin: '',
    destination: ''
  }

  start_: any;
  end_: any;

  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private _restService: RestService,
    private _addressService: AddressesService,
    private ubicacionesService: UbicacionesService,
     private _itineraryService: ItineraryService,
    public vcr: ViewContainerRef,
    private dialog: MatDialog,
    public userService: UserService,
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<RentcarsComponent>
  ) {
    this.dpConfig.containerClass = "theme-red";
    this.bgClientColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
    this.calendarSync = new DateRangePickerService();
   // this.minDate = new Date();
  }

  openDatepicker(datePiker: any ) {
    const mdPicker = document.querySelector('.md-drppicker');
        if (mdPicker) {
          this.calendarSync.setup(mdPicker as HTMLElement);
        }
    this.pickerDirectiveAll[datePiker].open();

    if(datePiker == "last"){
      this.pickerDirectiveAll["first"].hide();
    }else{
      this.pickerDirectiveAll["last"].hide();
    }

  }


  ngOnInit() {
    // `agencyData()` subscribes to itinerary$ which synchronously triggers
    // cdr.detectChanges(), so the form MUST exist before it runs.
    this.componentResults = !!(this.data && this.data?.component === 'results');
    if (this.data && this.data?.clientSetting) {
      this.getClientsSettingAppBooking = this.data?.clientSetting;
    }

    this.inicializedAtributtes();
    this.inicialzedForm();

    this.agencyData();

    this.loadingData = false;

  /// this.dateRange.startDate = moment().subtract(4, 'days').startOf('day');
    const quarterHours = ['00', '30'];
    for (let i = 0; i < 24; i++) {
      const suffix = i < 12 ? 'AM' : 'PM';
      const hour12 = i % 12 === 0 ? 12 : i % 12;

      for (const minutes of ['00', '30']){
        const label = `${hour12}:${minutes} ${suffix}`;
        const value = `${i.toString().padStart(2, '0')}:${minutes}`;

        this.times.push({label,value})
      }
    }

    if(!this.componentResults) {
      this._form.get('hourOrigin')?.patchValue('10:00');
      this._form.get('hourDestination')?.patchValue('10:00');
    }

    // (<HTMLInputElement>document.getElementById('dateStart')).value = '';
    // (<HTMLInputElement>document.getElementById('dateEnd')).value = '';

    this.validateDriverAge();

    }

    /**
 * Obtiene y establece el ID de la agencia desde localStorage o servicio de usuario
 *
 * Este método intenta recuperar la agencia seleccionada del localStorage y si no existe,
 * utiliza el ID de agencia del servicio de usuario como fallback.
 *
 * @returns {void}
 *
 * @priority
 * 1. ✅ Intenta obtener del localStorage key "selectedAgency"
 * 2. ✅ Si existe, usa agency_id del objeto almacenado
 * 3. ❌ Si no existe, usa this.userService._agencyID
 *
 * @storage
 * - localStorage key: "selectedAgency"
 * - Formato esperado: JSON string con objeto { agency_id: number }
 *
 * @fallback
 * - userService._agencyID: ID de agencia del usuario actual
 *
 * @example
 * // localStorage: '{"agency_id": 123}'
 * this.agencyData(); // agencyId = 123
 *
 * // localStorage: null
 * // userService._agencyID = 456
 * this.agencyData(); // agencyId = 456
 */
  agencyData(): void {
    let agency = JSON.parse(localStorage.getItem("selectedAgency"));
    if(agency) {
      this.agencyId = agency.agency_id;
    }else{
      this.agencyId = this.userService._agencyID;
    }

    this._itineraryService.itinerary$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }


  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngAfterViewInit() {
    setTimeout(() => {
      this.myInputField?.nativeElement.focus();
    }, 500);

     setTimeout(() => {
        this.setupAutocompleteStyles();
    });

    this.cdr.detectChanges();
  }


    /**
   * Hook reservado para ajustes futuros del autocomplete.
   *
   * Antes este metodo manipulaba inline styles sobre `.cdk-overlay-pane`
   * en cada evento (opened), pero eso causaba que el overlay del CDK
   * (que Angular Material reutiliza entre aperturas) arrastrara estilos
   * viejos y produjera anchos inconsistentes despues de borrar texto
   * o resetear el input con la X.
   *
   * El ancho dinamico ahora se calcula midiendo el contenido del panel
   * despues de que Angular Material lo renderiza, evitando los problemas
   * de reuso del overlay y los race conditions.
   */
    private setupAutocompleteStyles(): void {
      this.applyAutoWidth(this.autoOrigin);
      this.applyAutoWidth(this.autoDestination);
    }

    /**
     * Ajusta el ancho del overlay del CDK para que coincida con el contenido
     * del panel del autocomplete (fit-content real, midiendo los <mat-option>
     * ya renderizados).
     *
     * Estrategia:
     * 1) Al abrirse, esperamos un frame para que Angular Material termine de
     *    pintar las opciones dentro del panel.
     * 2) Recorremos todos los <mat-option> del panel, medimos su ancho real
     *    (incluyendo padding) y tomamos el maximo.
     * 3) Sumamos un pequeno padding de respiracion y lo aplicamos al
     *    cdk-overlay-pane padre (que es el nodo que Material usa para el
     *    ancho visible).
     *
     * Aplicamos el width via inline style SOLO en este momento y al elemento
     * especifico del panel actual. No leemos estilos inline viejos porque
     * sobreescribimos con el valor recalculado cada vez.
     *
     * @param auto - Referencia al MatAutocomplete cuyo panel queremos dimensionar
     */
    private applyAutoWidth(auto: MatAutocomplete | undefined): void {
      if (!auto) {
        return;
      }
      auto.opened.subscribe(() => {
        // Triple requestAnimationFrame: garantiza que Angular Material haya:
        // 1) Insertado el panel en el DOM
        // 2) Renderizado los <mat-option> con sus textos
        // 3) Calculado el layout final
        // Sin esto, scrollWidth reporta anchos del frame anterior (cuando
        // el panel aun estaba con width chico).
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.measureAndFitPanel(auto);
            });
          });
        });
      });
    }

    /**
     * Mide las opciones visibles del panel y aplica el ancho optimo al overlay.
     * Si por algun motivo no puede medir, cae a un default razonable.
     *
     * Angular Material aplica `text-overflow: ellipsis` sobre el <span> interno
     * (clase mat-option-text) cuando el contenedor es mas chico que el texto.
     * Para medir el ancho real del contenido sin truncado, removemos
     * temporalmente las restricciones de overflow en ese span y en el option.
     */
    private measureAndFitPanel(auto: MatAutocomplete): void {
      const panel = auto.panel?.nativeElement as HTMLElement | undefined;
      if (!panel) {
        return;
      }
      const overlay = panel.parentElement; // cdk-overlay-pane
      if (!overlay) {
        return;
      }

      // Truco clave: darle al panel un ancho "infinito" virtual para que los
      // textos largos NO se trunque mientras medimos.
      const originalPanelWidth = panel.style.width;
      panel.style.width = 'max-content';
      void panel.offsetWidth; // forzar reflow

      // Quitar restricciones de truncado en cada option y su <span> interno
      const options = panel.querySelectorAll('mat-option');
      const restoreStyles: Array<{ el: HTMLElement; prop: string; value: string }> = [];

      options.forEach((opt) => {
        const optEl = opt as HTMLElement;
        ['maxWidth', 'overflow', 'textOverflow'].forEach((prop) => {
          const camel = prop.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());
          const inlineVal = optEl.style.getPropertyValue(camel);
          if (inlineVal) {
            restoreStyles.push({ el: optEl, prop: camel, value: inlineVal });
            optEl.style.removeProperty(camel);
          }
        });

        // Tambien el <span> interno (mat-option-text) que Material usa para ellipsis
        const textSpan = optEl.querySelector('.mat-option-text') as HTMLElement | null;
        if (textSpan) {
          ['maxWidth', 'overflow', 'textOverflow'].forEach((prop) => {
            const camel = prop.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());
            const inlineVal = textSpan.style.getPropertyValue(camel);
            if (inlineVal) {
              restoreStyles.push({ el: textSpan, prop: camel, value: inlineVal });
              textSpan.style.removeProperty(camel);
            }
          });
        }
      });

      // Forzar otro reflow para que el browser recalcule los anchos sin truncado
      void panel.offsetWidth;

      // Medir el ancho real del contenido
      let maxWidth = 0;
      options.forEach((opt) => {
        const el = opt as HTMLElement;
        const textSpan = el.querySelector('.mat-option-text') as HTMLElement | null;
        // Medir el span interno que tiene el texto (es el que realmente trunca)
        const optWidth = textSpan ? textSpan.scrollWidth : el.scrollWidth;
        if (optWidth > maxWidth) {
          maxWidth = optWidth;
        }
      });

      // Restaurar estilos inline originales
      restoreStyles.forEach((rs) => {
        rs.el.style.setProperty(rs.prop, rs.value);
      });
      panel.style.width = originalPanelWidth;

      // Padding de respiracion + espacio para icono/check de Material
      const PADDING = 80;
      const desiredWidth = Math.max(maxWidth + PADDING, 420);

      // Limitar al viewport (dejando margen)
      const maxViewport = window.innerWidth * 0.95;
      const finalWidth = Math.min(desiredWidth, maxViewport);

      // Aplicar al overlay (que es lo que Angular Material usa para el width visible)
      const overlayEl = overlay as HTMLElement;
      overlayEl.style.width = `${finalWidth}px`;
      overlayEl.style.minWidth = `${finalWidth}px`;
      overlayEl.style.maxWidth = `${finalWidth}px`;
    }

  /**
   * Hook de apertura del mat-autocomplete.
   *
   * Se ejecuta cuando el usuario abre el dropdown de uno de los inputs
   * (origen o destino). Solo se usa como disparador para reposicionar/ajustar
   * estilos en `ngAfterViewChecked`; el ajuste real de ancho vive en
   * `setupAutocompleteStyles()`.
   *
   * @param which - 'origin' | 'destination' identifica qué input disparó el evento
   */
  onAutocompleteOpened(which: 'origin' | 'destination'): void {
    this.activeAutocomplete = which;
  }

  /**
   * Hook de cierre del mat-autocomplete.
   *
   * Limpia el identificador del dropdown activo para evitar aplicar
   * ajustes al panel equivocado si el DOM del CDK overlay aún contiene
   * referencias previas.
   *
   * @param which - 'origin' | 'destination' identifica qué input se cerró
   */
  onAutocompleteClosed(which: 'origin' | 'destination'): void {
    if (this.activeAutocomplete === which) {
      this.activeAutocomplete = null;
    }
  }

  /**
   * Cierra el panel de sugerencias de origen cuando el input queda vacío.
   *
   * Angular Material NO cierra el dropdown automáticamente al borrar el texto,
   * solo lo hace al perder foco o seleccionar una opción. Si el usuario borra
   * todo, queremos cerrarlo para evitar que quede un panel "fantasma" mostrando
   * resultados de la búsqueda anterior.
   *
   * @param event - Evento input nativo del <input> de origen
   */
  onOriginInputChanged(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    if (!value) {
      // Forzar el formControl a null para que valueChanges no reabra el panel
      // cuando el observable _addressService.getLocationsAll emita resultados vacios.
      if (this._form.get('origin')?.value) {
        this._form.get('origin')?.setValue(null, { emitEvent: false });
      }
      // En Angular Material 8 el closePanel vive en MatAutocompleteTrigger,
      // no en MatAutocomplete. Usamos el trigger asociado al input.
      if (this.originTrigger && this.originTrigger.panelOpen) {
        this.originTrigger.closePanel();
      }
    }
  }

  /**
   * Cierra el panel de sugerencias de destino cuando el input queda vacío.
   * Mismo razonamiento que `onOriginInputChanged`.
   *
   * @param event - Evento input nativo del <input> de destino
   */
  onDestinationInputChanged(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    if (!value) {
      if (this._form.get('destination')?.value) {
        this._form.get('destination')?.setValue(null, { emitEvent: false });
      }
      if (this.destinationTrigger && this.destinationTrigger.panelOpen) {
        this.destinationTrigger.closePanel();
      }
    }
  }

  _openModal() {
    this.isCollapsed = true;
    this._close = false;
    setTimeout(() => {
      this.modal.emit('true');
    }, 100);
  }

  inicializedAtributtes() {
    this._findData = false;
    this.isMeridian = false;
    this.isCollapsed = false;
    this.returnDestinations = true;
    this.inicializedArraySelect();
  }

  inicializedArraySelect() {
    this._addressDestinyRentaCar = [];
    this._addressOriginRentaCar = [];
    this._addressDestinyRentaCar.push(this.getSelectValueDefault());
    this._addressOriginRentaCar.push(this.getSelectValueDefault());
  }

  getSelectValueDefault(): IAddreSelect {
    return {
      id: "",
      address: "Select Pickup location",
    };
  }

  inicialzedForm() {
    this._form = this.fb.group({
      origin: ['', Validators.required],
      destination:  [''],
      dateStarEnd: [''],
      dateStar: ['',],
      dateEnd: ['',Validators.required],
      age: ['', Validators.required],
      hourOrigin: ['', Validators.required],
      hourDestination: ['', Validators.required],
      nationality: ['', Validators.required],
      typeOrigin: [''],
      typeDestination: [''],
      returnDestinations: [true]
    });


  this._form.get('origin')?.valueChanges.pipe(
      filter(selectedValue => !!selectedValue),
    ).subscribe((selectedValue) => {
      this.originOptions = this._addressService.getLocationsAll(
        selectedValue,
        null,
        false,
        'RENTCAR'
      );
    });

  this._form.get('destination')?.valueChanges.pipe(
      filter(selectedValue => !!selectedValue),
    ).subscribe((selectedValue) => {
      this.destinationOptions = this._addressService.getLocationsAll(
        selectedValue,
        null,
        false,
        'RENTCAR'
      );
    });


    this._form.controls['destination'].disable();
        this.dateRange = "";

            if(this.componentResults) {
               this.getCountries(true);

            }

  }

  formPatchValue(): void {

    if(this.data && this.data?.category) {

      if(this.data.payload && Array.isArray(this.data.payload) && this.data.payload.length === 0) {
        this.loadingData = false;
        return;
      }

    const payload = this.data.payload[0];

    if(this.data.category !== this.data.payload[0].categoriesId[0]) {
      this.loadingData = false;
      return;
    }

      switch(this.data.category) {

        case 2:

            if(!payload) {
              this.loadingData = false;
              return;
            }

          if(payload.categoriesId[0] === 2) {

            const [arrivalYear, arrivalMonth, arrivalDay] = payload.arrivalDate.split('-');
            let arrivalDate = new Date(Number(arrivalYear), Number(arrivalMonth) - 1, Number(arrivalDay));

                    // Para departureDate (mismo método)
            const [departureYear, departureMonth, departureDay] = payload.departureDate.split('-');
                    let departureDate = new Date(Number(departureYear), Number(departureMonth) - 1, Number(departureDay));

                    if(isNaN(arrivalDate.getTime())){
                      arrivalDate = dayjs(payload.arrivalDate).startOf('day').toDate()
                    }

                    if(isNaN(departureDate.getTime())){
                       departureDate = dayjs(payload.departureDate).startOf('day').toDate();
                    }


          this.returnDestinations = this._form.value.returnDestinations;
            if (!this.returnDestinations) {
              this._form.controls['destination'].setValue('');
              this._form.controls['destination'].disable();
            } else {
              // eslint-disable-next-line max-len
              this._form.get('destination')?.enable();
              this._form.controls['destination'].setValue( this._form.controls['origin'].setValue);
            }

          // Asignación al formulario
          this._form.patchValue({
            origin: this?.data?.form?.origin?.iata,
            destination: this._form.value.returnDestinations ? '' : payload.others?.carRental?.dropoffLocation?.destination?.iata,
            qtyProduct: this.data.form.qtyProduct,
            dateStarEnd: {
              start: arrivalDate,
              end: departureDate
            },
            returnDestinations: this._form.value.returnDestinations,
            hourOrigin: '',
            hourDestination: '',

          });

          }

        this.originOptions.pipe(
          filter(value => !!value),
          switchMap(() => this.originOptions),
          filter(options => options && options.length > 0),
          take(1)).subscribe((data: any) => {
          let typeOrigin: string = '';
          if (data && data.length > 0) {
            let destination = data
              .flatMap((element: any) => element.cities || [])
              .find((c: any) => c.city_name === this.data.form.origin.city_name);

            if(destination) {
              typeOrigin = 'city';
            }
            // Si no se encontró en cities, buscar en airports
            if (!destination) {
              destination = data
                .flatMap((element: any) => {
                  if (element.airports && Array.isArray(element.airports) && element.airports.length > 0) {
                    return element.airports;
                  }
                  return [];
                })
                .find((a: any) => a.name === this.data.form.origin.name || a?.iata === this.data.form.origin?.iata);
            }

            if (destination) {
              if(typeOrigin === '') {
                typeOrigin = 'airport'
              }
              this.updateMySelectionOrigin({data: destination, type: typeOrigin});
              this.updateMySelectionNationality(this.data.form.nationality);

              this._form.patchValue({
                origin: destination
              });
              this.loadingData = false;
            }
          }
        });

if(!this._form.value.returnDestinations) {
      this.destinationOptions.pipe(
                filter(value => !!value),
                switchMap(() => this.originOptions),
                filter(options => options && options.length > 0),
                take(1)
              ).subscribe((data: any) => {
                     let typeDestination: string = '';
                    if(data && data.length > 0) {
                      let destination = data
                      .flatMap((element: any) => element.cities || [])
                      .find((c: any) => c.city_iata_code ===  payload.others?.carRental.dropoffLocation.destination);

                      if(destination) {
                        typeDestination = 'city';
                      }

                        // Si no se encontró en cities, buscar en airports
                      if (!destination) {
                        destination = data
                          .flatMap((element: any) => {
                            // Verificar si tiene airports y es un array de objetos
                            if (element.airports && Array.isArray(element.airports) && element.airports.length > 0) {
                              return element.airports;
                            }
                            return [];
                          })
                          .find((a: any) => a.name ===  payload.others?.carRental.dropoffLocation.destination || a?.iata_code ===  payload.others?.carRental.dropoffLocation.destination);
                        }

                    if(destination) {
                      if(typeDestination === '') {
                        typeDestination = 'airport';
                      }
                      this.updateMySelectionDestination({data: destination, type: typeDestination});
                        this._form.patchValue({
                          origin: destination,
                        })
                    }
                  }


                  //  this._form.patchValue({
                  //     origin: this.data.form.origin
                  //   })
              })
}


      }
    }

  }

  private convertTo12HourFormat(time24: string): string {
  if (!time24) return '';

  // time24 viene como "10:00:00"
  const [hours, minutes] = time24.split(':');
  const hour = parseInt(hours, 10);
  const min = minutes;


  return `${hours}:${min}`; // "10:00 AM"
}



  change(event: any) {

  }

  change_(event: any) {
  }

  choosedDate($event) {
  }

  startDateClicked($event) {
    this.endDate = null;
    this.startDate = $event;
    this.onDateRangeChange();

    // eslint-disable-next-line max-len
    (<HTMLInputElement>document.getElementById('dateStart')).value = moment($event.startDate.$d.toString().split(",")[0]).format("DD-MM-YYYY");

    // eslint-disable-next-line max-len
    this._form.controls['dateStar'].setValue( moment($event.startDate.$d.toString().split(",")[0]).format("DD-MM-YYYY"));
  }


  datesUpdated($event) {

  }

  rangeClicked($event) {
  }

  endDateClicked($event) {
    this.endDate = $event;
 // eslint-disable-next-line max-len
  //  (<HTMLInputElement>document.getElementById('dateEnd')).value = moment($event.endDate.$d.toString().split(",")[0]).format("DD-MM-YYYY");
   this._form.controls['dateEnd'].setValue( moment($event.endDate.$d.toString().split(",")[0]).format("DD-MM-YYYY"));
  }

  numberAge():void{
    this._form.controls['age'].setValue(String(this.ageDefault));
  }

  _onSubmit(form: FormGroup, event?: Event, dummy?: Object) {


    if(this.userService.itineraryActive.length == 0) {
      return;
    }
    if(this._form.get('age')?.value < 20) {
      return;
    }

    if(!this._form.valid) {
       Object.keys(form.controls).forEach(key => {
        const control = form.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });


      return;
    }

    const _payload = [];

    if (event) {
      event.preventDefault();
    }
    this._emitLoading(true);

    this.numberAge();

    const extras = {
      returnDestinations: this.returnDestinations,
    };

    if(this.dateRange.start === null && this.dateRange.end === null){
      this.dateRange.start = this.data.payload[0].arrivalDate;
      this.dateRange.end = this.data.payload[0].departureDate;
    }

    // eslint-disable-next-line max-len

    const payload = searchPayload("RENT-A-CAR", this.dateRange, form, this.selectedDestiny, this.selectedOrigin, extras, null, this.selectNationality, this.agencyId, '', null, this.typeOriginDestination);

    payload.providersId = this.userService._providerId;

    if(form.value.origin.type) {
      form.get('origin')?.setValue(form.value.origin.data);
    }

    if(form.value.destination && form.value.destination.type) {
      form.get('destination')?.setValue(form.value.destination.data);
    } else {
       form.get('destination')?.setValue(form.value.origin.data);
    }

    localStorage.setItem("form", JSON.stringify(form.value));

    if (localStorage.getItem("payload")) {
      localStorage.removeItem("payload");
    }
    _payload[0] = payload;
    localStorage.setItem("payload", JSON.stringify(_payload));

     if(this.componentResults) {
        this.dialogRef.close(payload);
        localStorage.setItem('origin', 'RENT-A-CAR');
    } else {

    this._emitLoading(true);
    this._restService.doPost('app', 'search', dummy || payload).subscribe(
      (response: any) => {
        if (response !== null && response.results !== null && !Array.isArray(response)) {
          const payloadArray = [payload];
          this.payload.emit(payloadArray);
          this._setSearchIdInResults(response);
          this._setArrivalAndDepartureDate(response, form);
          this._handleResponse(response, "RENT-A-CAR", form);
          this._emitOrigin("RENT-A-CAR");
          this._emitLoading(false);
          this._router.navigate(["/results"]);
        } else {
          setTimeout(() => {
              this._emitLoading(false);
                const initialState: ModalOptions = {
                  initialState: {
                    message: '',
                    confirmText: 'Cerrar',
                    cancelText: 'Volver a intentar',
                    showCancelButton: true,
                    size: 'sm',
                  }
                };
                const modalOptions = Object.assign({}, initialState, this.config);
                this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);
                const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
                  if (!result) {
                    this._onSubmit(form, event);
                  } else {
                    this.bsModalRef.hide();
                    this._router.navigate(["/home"]);
                  }
                  confirmSubscription.unsubscribe();
                });
          }, 3000);


        }
      },
      (error) => {
        setTimeout(() => {
          this._emitLoading(false);
            const initialState: ModalOptions = {
              initialState: {
                message: 'Ocurrió un error al intentar encontrar productos. Inténtalo de nuevo'
              }
            };

            this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
            const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
              if(result) {
                if (result) {
                  this._onSubmit(form, event);
                } else {
                  this.bsModalRef.hide();
                  this._router.navigate(["/home"]);
                }
              } else {

              }
              confirmSubscription.unsubscribe();
            });
        }, 3000);

      }
    );
    }
  }

  _colocarSearchIdEnRentaCAr(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
    return response;
  }

  validateSelectLocations() {
    let valido = false;
    if (this.selectedOrigin !== undefined && this.selectedOrigin !== null) {
      if (!this.returnDestinations) {
        if (this.selectedDestiny !== undefined && this.selectedDestiny !== null) {
          valido = true;
        } else {
          valido = false;
        }
        return valido;
      } else {
        valido = true;
      }
      return valido;
    }
    return valido;
  }

  _setSearchIdInResults(response: any) {
      response.results.forEach((obj) => {
        obj.searchId = response.searchId;
      });
  }

  onReturnChange() {
    this.returnDestinations = !this.returnDestinations;
  }

  _setArrivalAndDepartureDate(response: any, form) {
    response.results.forEach((obj) => {
      obj.dateIni = moment(this.dateRange.start.$d.toString().split(",")[0]).format("YYYY-MM-DD");
      obj.dateEnd = moment(this.dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD");
    });
  }

  _handleResponse(response: any, categoryName: string, form: FormGroup) {
    if (response && response.results != null) {
      try {
        this._resultsQuery = response.results;
        this._resultsQuery.categoryName = categoryName;
        this._resultsQuery.destination = this._longDestination;
        this._resultsQuery.origin = this._longOrigin;

        if (!response.results.length) {
          this._resultsQuery.noResultMessage = "No results found for the search";
        }
        // se anexa el formulario actual
        this._resultsQuery.form = form;
        const arrayResults = [this._resultsQuery];
        this.results.emit(arrayResults);
      } catch (e) {
        this._resultsQuery = [];
        this._restService.page = 1;
      }
    } else {
      this._resultsQuery = [];
      this._resultsQuery.noResultMessage = "No results found for the search";
      this.results.emit(this._resultsQuery);
    }
  }

  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }

  _payload(form: FormGroup, dest: string, orig: string) {
    const payload = {
      providersId: [],
      categoriesId: [2],
      origin: orig,
      destination: dest !== undefined ? dest : orig,
      priceFrom: null,
      priceTo: null,
      arrivalDate: moment(form.value["arrivalDate"].toString().split(",")[0]).format("YYYY-MM-DD"),
      departureDate: moment(form.value["departureDate"].toString().split(",")[0]).format("YYYY-MM-DD"),
      qtyProduct: 1,
      others: {
        maxRequestTimeOnSeconds: 20,
        minNumResults: 10,
        carRental: {
          pickupLocation: {

            id: this.addreOriginSelected.id, // 'QDrQ6XlzSdoJWW3YuCk0zv6DePiEnevJFhtX7dmQqJ8=.'
            address: this.addreOriginSelected.address,
          },
          dropoffLocation: {
            // eslint-disable-next-line max-len
            id: !this.returnDestinations ? this.addreDestinySelected.id : this.addreOriginSelected.id, // 'QDrQ6XlzSdoJWW3YuCk0zv6DePiEnevJFhtX7dmQqJ8=.'
            address: !this.returnDestinations ? this.addreDestinySelected.address : this.addreOriginSelected.address,
          },
        },
      },
    };
    return payload;
  }

  _emitOrigin(origin: any) {
    this.origin.emit(origin);
  }

  /***********************************************Auto Complete********************************************/
  _myListFormatter = (data: any) => {
  }


  _myCallback(data: any) {

  }

  observableSource = (keyword: any): Observable<any[]> => {
    return this.ubicacionesService.getCitys(keyword);
  };

  displayFn(name: any) {


    if (name?.iata) {

      if (name?.name != undefined) {
        this._origin = name;
        return name?.name;
      }
      // if (name.name_airport != undefined) {
      //   return name.name_airport;
      // }
    }
    if(name?.city_iata){
      if (name?.city_name != undefined) {
        return name?.city_name;
      }
    }

    if(name?.hotel_name){
      if (name?.hotel_name != undefined) {
        return name?.hotel_name;
      }
    }
  }

  updateMySelectionOrigin(selected: {data: any, type: string}) {

    const event = selected.data;
    const type = selected.type;
    this.typeOriginDestination.origin = type;

    if (event) {
      this.typeOrigin = type;
      this._form.get('typeOrigin')?.setValue(type);

      if(this.typeOrigin === 'airport'){
      this._origin = event.name ? event.name : "";
      this._longOrigin = event.province_name ? event.province_name : "";
      this.selectedOrigin = event?.iata ? event?.iata : "";
      this.originInputValue = `${this._origin}, ${this.selectedOrigin}`

      }

      if(this.typeOrigin === 'city'){
      this._origin = event.city_name ? event.city_name : "";
      this._longOrigin = event.city_province ? event.city_province : "";
      this.selectedOrigin = event.city_iata_code ? event.city_iata_code : "";
      this.originInputValue = `${this._origin}, ${this._longOrigin}, ${this.selectedOrigin}`

      }

      if(this.typeOrigin === 'hotel'){
      this._origin = event.name ? event.name : "";
      this._longOrigin = event.province_name ? event.province_name : "";
      this.selectedOrigin = event?.iata ? event?.iata : "";

      this.originInputValue = `${this._origin}, ${this._longOrigin}, ${this.selectedOrigin}`
      }

    }

  }


  updateMySelectionDestination(selected: {data: any, type: string}) {

    const event = selected.data;
    const type = selected.type;
    this.typeOriginDestination.destination = type;

    if (event) {
      this._form.get('typeDestination')?.setValue(type);
      this.typeDestination = type;
      // this._longOrigin = event.province_name ? event.province_name : "";

      if(this.typeDestination === 'airport'){
      this.destiny = event.name ? event.name : "";
      this._longDestination = event.province_name ? event.province_name : "";
      this.selectedDestiny = event.iata ? event.iata : "";
      this.destinyInputValue = `${this.destiny}, ${this.selectedDestiny}`

      }

      if(this.typeDestination === 'city'){
      this.destiny = event.city_name ? event.city_name : "";
      this._longDestination = event.city_province ? event.city_province : "";
      this.selectedDestiny = event.city_iata_code ? event.city_iata_code : "";
      this.destinyInputValue = `${this.destiny}, ${this._longDestination}, ${this.selectedDestiny}`

      }

      if(this.typeDestination === 'hotel'){
      this.destiny = event.name ? event.name : "";
      this._longDestination = event.province_name ? event.province_name : "";
      this.selectedDestiny = event?.iata ? event?.iata : "";

      this.destinyInputValue = `${this.destiny}, ${this._longDestination}, ${this.selectedDestiny}`
      }


      // if (this.returnDestinations) {
      // eslint-disable-next-line
      //     this._form.controls['destination'].setValue( this._form.controls['origin'].setValue);
      // }
    }
  }

  /***********************************************Auto Complete********************************************/

  fillDirectionsByIataCode(iataCode: any, addre: any, isOrigin: boolean) {
    let response;
    let type: any;
    //this._addressService.getAddress(iataCode, addre, 2).subscribe(
    this._addressService._getAddress(iataCode, addre, 2, type).subscribe(
      (response: any) => {
        if (response) {
          if (isOrigin) {
            this._addressOriginRentaCar = [];
            this._addressOriginRentaCar.push(this.getSelectValueDefault());
          } else {
            this._addressDestinyRentaCar = [];
            this._addressDestinyRentaCar.push(this.getSelectValueDefault());
          }
          response.forEach((obj) => {
            if (isOrigin) {
              if (!this._addressOriginRentaCar.includes(obj)) {
                this._addressOriginRentaCar.push(obj);
              }
            } else {
              if (!this._addressDestinyRentaCar.includes(obj)) {
                this._addressDestinyRentaCar.push(obj);
              }
            }
          });
        }
      },
      (error) => {
        console.log("Error consulting Address in rentacar");
      }
    );
  }

  fillObject(id: any, origin: boolean) {
    //console.log("id.value", id.value);
    if (origin) {
      this.addreOriginSelected = this._addressOriginRentaCar.find((obj) => obj.id === id.value);
    } else {
      this.addreDestinySelected = this._addressDestinyRentaCar.find((obj) => obj.id === id.value);
    }
  }

  changueReturnDestinations() {

    this.returnDestinations = !this.returnDestinations;
    if (!this.returnDestinations) {
      this._form.get('destination')?.enable();
      this._form.controls['destination'].setValue('');

    } else {
      // eslint-disable-next-line max-len
      this._form.controls['destination'].disable();
      this._form.controls['destination'].setValue( this._form.controls['origin'].setValue);
    }
  }


      close(): void {

    this.dialogRef.close(null);
  }


openDatePicker() {

  if (this.picker && this.componentResults) {
    this.picker.open();

    setTimeout(() => {
      const pickerElement = document.querySelector('ngx-daterangepicker-material') as HTMLElement;
      const inputElement = document.querySelector('.input-search-box') as HTMLElement;

      if (pickerElement && inputElement) {
        // Calculamos la posición del input en el viewport
        const inputRect = inputElement.getBoundingClientRect();

        // Ajustamos la posición del picker relativa al input
        pickerElement.style.position = 'fixed';
        pickerElement.style.top = `${inputRect.bottom + window.scrollY}px`;
        pickerElement.style.left = `${inputRect.left + window.scrollX}px`;
        pickerElement.style.transform = 'none';
        pickerElement.style.maxHeight = 'none';
        pickerElement.style.overflow = 'visible';
        pickerElement.style.zIndex = '9999';

        // Verificamos si el picker se sale de la pantalla y ajustamos
        this.adjustElementPosition(pickerElement, inputRect);
      }
    });
  }

}

// Método para ajustar la posición si se sale del viewport
adjustElementPosition(pickerElement: HTMLElement, inputRect: DOMRect) {
  const pickerRect = pickerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Ajuste vertical (si no cabe abajo, mostramos arriba)
  if (pickerRect.bottom > viewportHeight) {
    pickerElement.style.top = `${inputRect.top + window.scrollY - pickerRect.height}px`;
  }

  // Ajuste horizontal (si no cabe a la derecha, alineamos a la izquierda)
  if (pickerRect.right > viewportWidth) {
    pickerElement.style.left = `${viewportWidth - pickerRect.width - 10}px`;
  }
}

    resetOrigin(): void {
    // Cerrar el panel antes de resetear para que el overlay se libere
    // y la próxima apertura dispare un recalculo limpio del ancho.
    if (this.originTrigger && this.originTrigger.panelOpen) {
      this.originTrigger.closePanel();
    }
    this._form.get('origin').setValue(null);
    this._form.get('typeOrigin').setValue(null);
    this._origin = undefined;
    this.selectedOrigin = undefined;
    this._longOrigin = undefined;
    this.originInputValue = undefined;
  }


    resetDestiny(): void {
    if (this.destinationTrigger && this.destinationTrigger.panelOpen) {
      this.destinationTrigger.closePanel();
    }
    this._form.get('destination').setValue(null);
    this._form.get('typeDestination').setValue(null);
    this.destiny = undefined;
    this.selectedDestiny = undefined;
    this._longDestination = undefined;
    this.destinyInputValue = undefined;
  }


  validateDriverAge():void{

    this._form.get('age').valueChanges.subscribe((age:number) =>{
      if(age < 21){
        this.messageValidateAge =  `Los conductores menores de 20 años no pueden alquilar vehículos.`;
      }else if(age > 20 && age < 25){
         this.messageValidateAge =  `Algunas compañías podrían aplicar cargos extras en destino si el conductor tiene entre 21 y 24 años.`;
      } else {
        this.messageValidateAge = null;
      }
    })

  }


 limitAgeLength(event: any) {
  const input = event.target;
  if (input.value.length > 2) {
    input.value = input.value.slice(0, 2);
  }
}


// validateDataModal(){
//   if(this.data.category == 2 && this.data.payload[0].categoriesId[0] == 2){
//     this.updateMySelectionOrigin(this.data.form.origin)
//   }
// }

  /***********************************************Auto Complete********************************************/

  /**
 * Convierte un string a formato de título (Title Case) con manejo de valores nulos
 *
 * Este método transforma un string capitalizando la primera letra de cada palabra
 * y poniendo el resto en minúsculas, con validación robusta para valores edge.
 *
 * @param {any} val - Valor a capitalizar (se convierte a string si es posible)
 * @returns {string} - String en Title Case o valor original si no es capitalizable
 *
 * @validation
 * - Rechaza undefined, null y string vacío
 * - Retorna el valor original si no pasa validación
 *
 * @process
 * 1. toLowerCase(): Convierte todo a minúsculas
 * 2. trim(): Elimina espacios en blanco al inicio/final
 * 3. split(" "): Divide por espacios en array de palabras
 * 4. map(): Capitaliza primera letra de cada palabra
 * 5. join(" "): Une palabras con espacios
 *
 * @example
 * capitalize("new york city") → "New York City"
 * capitalize("juan pérez") → "Juan Pérez"
 * capitalize(null) → null
 */
capitalize(val: any): string {
  if (!val && val !== 0) return ''; // Manejar null, undefined, empty string, pero mantener 0

  return String(val)
    .toLowerCase()
    .trim()
    .split(/\s+/) // Divide por uno o más espacios
    .filter(word => word.length > 0) // Filtra palabras vacías
    .map(word => {
      // Encontrar el primer carácter alfabético
      const firstLetterMatch = word.match(/[a-zñáéíóúü]/i);

      if (firstLetterMatch) {
        const firstLetterIndex = firstLetterMatch.index || 0;
        // Capitalizar la primera letra alfabética encontrada
        return word.substring(0, firstLetterIndex) +
               word[firstLetterIndex].toUpperCase() +
               word.substring(firstLetterIndex + 1);
      }

      // Si no hay letras, devolver la palabra tal cual
      return word;
    })
    .join(' ');
}

  /**
 * Actualiza la selección de nacionalidad y sincroniza con el formulario
 *
 * Este método procesa la selección de nacionalidad, actualizando el formulario
 * y las propiedades internas con validación adecuada.
 *
 * @param {any} event - Código de país seleccionado para nacionalidad
 * @returns {void}
 *
 * @actions
 * 1. Actualiza el control de formulario 'nationality' con el valor
 * 2. Limpia errores de validación del control
 * 3. Actualiza valueAndValidity del control
 * 4. Busca y almacena el nombre del país correspondiente
 * 5. Almacena el código de país en selectNationality
 *
 * @uses
 * - filteredCountries: Array de países disponibles para búsqueda
 */
  updateMySelectionNationality(event: any) {
    if(event) {
      this._form.get('nationality').setValue(event);
      this._form.get('nationality').setErrors(null);
      this._form.get('nationality').updateValueAndValidity();
      this.selectNationalityName = this.filteredCountries.find(c => c.country_code == event)?.country_name;
      this.selectNationality = event;
    }
  }


    /**
   * Obtiene la lista de países disponibles desde el API
   *
   * Este método realiza una llamada HTTP para obtener todos los países
   * y los almacena para su uso en dropdowns de nacionalidad y filtros.
   *
   * @param {boolean} [researchData] - Flag opcional para indicar si se debe hacer formPatchValue después
   * @returns {void}
   *
   * @api
   * - Endpoint: GET "/utilities/countries"
   * - Service: _itineraryService._restService.doGet
   *
   * @processing
   * 1. Realiza llamada HTTP para obtener países
   * 2. Almacena en countriesData y filteredCountries
   * 3. Si researchData es true, ejecuta formPatchValue()
   *
   * @memoryManagement
   * - Usa takeUntil(this._unsubscribeAll) para evitar memory leaks
   * - Se desuscribe automáticamente cuando el componente se destruye
   */
    getCountries(researchData?: boolean) {
      this._itineraryService._restService.doGet("api", "/utilities/countries")
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.countriesData = res.Countrys;
          this.filteredCountries = this.countriesData;
          if(this.filteredCountries && this.componentResults) {

            if(this.componentResultsFirstCharge) {

              this.formPatchValue();
            }
            this.componentResultsFirstCharge = false;
          }
        }
      })
    }

      /**
 * Filtra la lista de países basado en el texto de búsqueda ingresado
 *
 * Este método filtra el array de países disponibles (countriesData) para mostrar
 * solo aquellos cuyo nombre coincide con el texto de búsqueda, con búsqueda case-insensitive.
 *
 * @param {string} searchText - Texto de búsqueda ingresado por el usuario
 * @returns {void}
 *
 * @filterLogic
 * - Si searchText existe: Filtra países que contengan el texto (case-insensitive)
 * - Si searchText está vacío/null/undefined: Muestra todos los países
 *
 * @searchBehavior
 * - Búsqueda parcial: includes() en lugar de igual exacto
 * - Case-insensitive: Convierte ambos lados a minúsculas
 * - Tiempo real: Se ejecuta con cada cambio en el input de búsqueda
 *
 * @performance
 * - Filtrado client-side: No requiere llamadas adicionales al API
 * - Operación sincrónica: Respuesta inmediata
 *
 * @example
 * // searchText = "mex" → muestra "Mexico"
 * // searchText = "uni" → muestra "United States", "United Kingdom"
 * // searchText = "" → muestra todos los países
 */
  filterCountries(searchText: string) {
    if (searchText) {
      this.filteredCountries = this.countriesData.filter(country =>
        country.country_name.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      this.filteredCountries = this.countriesData;
    }
  }

    /**
 * Función de display para mostrar el nombre del país en campos de selección
 *
 * Este método toma un código de país y retorna el nombre correspondiente
 * para mostrar en interfaces de usuario, con manejo de errores robusto.
 *
 * @param {any} country - Código de país (ej: "US", "MX") o null
 * @returns {string} - Nombre del país o string vacío si no se encuentra
 *
 * @process
 * 1. Verifica que filteredCountries esté definido
 * 2. Busca el país por country_code en filteredCountries
 * 3. Maneja caso especial cuando country es null
 * 4. Retorna el country_name o string vacío
 *
 * @errorHandling
 * - Console.error si filteredCountries no está definido
 * - Retorna string vacío en casos de error o no encontrado
 *
 * @usage
 * Utilizado por componentes de selección (dropdowns, autocomplete)
 * para mostrar nombres amigables en lugar de códigos
 *
 * @example
 * displayCountry("US") → "United States"
 * displayCountry("MX") → "Mexico"
 * displayCountry(null) → ""
 */
  displayCountry = (country: any) => {
    if (!this.filteredCountries) {
      console.error('filteredCountries is not defined');
      return '';
    }
    let countryData = this.filteredCountries.find(c => c.country_code === country);
    if(country === null) {
      countryData = null;
    }
    return countryData ? `${countryData.country_name}` : '';
  }

    /**
 * Reinicia la selección de nacionalidad a estado inicial
 *
 * Este método limpia completamente la selección de nacionalidad,
 * incluyendo el control del formulario y las propiedades internas.
 *
 * @returns {void}
 *
 * @actions
 * 1. Setea el control de formulario a null
 * 2. Establece error de validación personalizado
 * 3. Limpia el nombre de nacionalidad
 * 4. Limpia el código de nacionalidad
 *
 * @validation
 * - Setea error {error: true} para indicar que es requerido
 */
  resetNationality(): void {
    this._form.get('nationality').setValue(null);
    this._form.get('nationality').setErrors({error: true});
    this.selectNationalityName = '';
    this.selectNationality = '';

  }

    /**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

getStyleBackgroundReturn(): string {

  if(!this.returnDestinations) {
    return 'white';
  } else {
    return '#effef9';
  }

}

onDateRangeChange(): void {
    if (this.startDate && !this.endDate) {
            this.calendarSync.setStartDate(this.startDate ? this.startDate : this.dateRange.start);
        }
    if (this.startDate && this.endDate) {
            this.calendarSync.clearStartDate();
        }
}

// ponytail: times[] array below may be dead code after wheel-picker migration — HTML no longer consumes it
now = new Date();
currentTime = this.now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
activeTimePicker: 'hourOrigin' | 'hourDestination' | null = null;

toggleTimePicker(pickerId: 'hourOrigin' | 'hourDestination', event: Event): void {
  event.stopPropagation();
  this.activeTimePicker = this.activeTimePicker === pickerId ? null : pickerId;
}

closeTimePicker(): void {
  this.activeTimePicker = null;
}

/**
 * Free-form input. Validation is deferred to blur so the user can type
 * partial values like "1" or "13:" without being snapped back.
 */
onHourInput(event: Event, field: 'hourOrigin' | 'hourDestination'): void {
  const input = event.target as HTMLInputElement;
  const sanitized = input.value.replace(/[^\d:]/g, '').slice(0, 5);
  if (sanitized !== input.value) {
    input.value = sanitized;
  }
  this._form.get(field)?.setValue(sanitized, { emitEvent: false });
}

/** Validate and normalize on blur. Falls back to current value if invalid. */
onHourBlur(event: Event, field: 'hourOrigin' | 'hourDestination'): void {
  const input = event.target as HTMLInputElement;
  const raw = (input.value || '').trim();
  if (!raw) {
    const fallback = this.currentTime || '00:00';
    this._form.get(field)?.setValue(fallback);
    input.value = fallback;
    return;
  }
  const match = /^(\d{1,2})(?::?(\d{0,2}))?$/.exec(raw);
  if (!match) {
    this.restoreHourField(input, field);
    return;
  }
  const hour = parseInt(match[1], 10);
  const minuteRaw = match[2] ?? '';
  const minute = minuteRaw === '' ? 0 : parseInt(minuteRaw, 10);
  if (Number.isNaN(hour) || hour < 0 || hour > 23 ||
      Number.isNaN(minute) || minute < 0 || minute > 59) {
    this.restoreHourField(input, field);
    return;
  }
  const normalized = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  this._form.get(field)?.setValue(normalized);
  input.value = normalized;
}

private restoreHourField(input: HTMLInputElement, field: 'hourOrigin' | 'hourDestination'): void {
  const current = (this._form.get(field)?.value as string) || this.currentTime || '00:00';
  this._form.get(field)?.setValue(current);
  input.value = current;
}

// Tracks where the user pressed the mouse down, so we can distinguish
// a "click" that ended inside a text field (e.g. finishing a text
// selection or pressing Cmd+A) from a genuine click-outside on a
// backdrop or unrelated element. Without this guard, releasing the
// mouse inside an <input> fires a `click` on `document` and the
// time picker would close mid-selection.
private mouseDownTarget: EventTarget | null = null;

@HostListener('document:mousedown', ['$event'])
onDocumentMouseDown(event: MouseEvent) {
  this.mouseDownTarget = event.target;
}

@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  // If the click originated inside a text-editable element, ignore it.
  // This covers Cmd+A / drag-to-select inside any <input>, <textarea>
  // or <select> belonging to the form: the `mousedown` happened there,
  // the `click` bubbles up to `document`, and we must NOT close the
  // time picker mid-selection.
  const downOnTextField =
    this.mouseDownTarget instanceof HTMLInputElement ||
    this.mouseDownTarget instanceof HTMLTextAreaElement ||
    this.mouseDownTarget instanceof HTMLSelectElement;
  this.mouseDownTarget = null;
  if (downOnTextField) {
    return;
  }

  if (this.activeTimePicker) {
    const target = event.target as HTMLElement;
    const pickerWrapper = target.closest('.wheel-picker-wrapper');
    if (!pickerWrapper) {
      this.activeTimePicker = null;
    }
  }
}
}

